module.exports = __webpack_public_path__ + "img/arrow-up.c731c3f4.svg";